export var cifEe = ["301 191", "<g fill='none'><path fill='#4891D9' d='M.5.5h300v190H.5z'/><path fill='#000' d='M.5 63.833h300V190.5H.5z'/><path fill='#FFF' d='M.5 127.166h300v63.333H.5z'/></g>"];
